export const parseVarianceInputValue = (
  value: unknown,
  options?: { finalize?: boolean }
): number | null => {
  const finalize = options?.finalize ?? false;

  if (value === '' || value === null || value === undefined) {
    return 0;
  }

  if (value === '-' || value === '-.') {
    return finalize ? 0 : null;
  }

  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : null;
};
